var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('titlebar',{attrs:{"title-stack":_vm.titleStack}}),_c('contaPagar',{attrs:{"model":_vm.model}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }